"use client";

import {Box, ButtonProps, Dialog, Flex, Icon, LinkBox, LinkBoxProps, LinkOverlay} from "@chakra-ui/react";
import NextLink from "next/link";
import Button from "./Button";
import {PlayIcon as PlayIconSolid} from "@heroicons/react/20/solid";
import {PlayIcon} from "@heroicons/react/24/outline";
import {useCallback} from "react";
import NextImage from "./Image";
import {StaticImageData} from "next/image";
import {redirect, usePathname} from "next/navigation";

export const WatchVideo = ({isOpen, url}: {isOpen?: boolean; url: string}) => {
  const pathname = usePathname();
  const onClose = useCallback(() => redirect(`${pathname}/..`), [pathname]);

  return (
    <Dialog.Root open={isOpen ?? false} onOpenChange={onClose} size="xl" lazyMount>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Body bg="black" p={4}>
            <Box position="relative" pb="56.25%" h="0">
              <Box asChild border="none" position="absolute" top="0" left="0" w="full" h="full">
                <iframe src={url} allowFullScreen />
              </Box>
            </Box>
          </Dialog.Body>
        </Dialog.Content>
        w
      </Dialog.Positioner>
    </Dialog.Root>
  );
};

export const WatchVideoButton = (props: ButtonProps) => {
  const pathname = usePathname();
  return (
    <Button href={`${pathname}/demo-video`} variant="outline" rounded="full" size="lg" {...props}>
      <Icon>
        <PlayIconSolid />
      </Icon>
      Watch video
    </Button>
  );
};

export const WatchVideoImage = ({href, src, ...props}: {src: StaticImageData; href: string} & LinkBoxProps) => (
  <LinkBox position="relative" cursor="pointer" transition="ease-in-out .2s" {...props}>
    <LinkOverlay asChild>
      <NextLink href={href} />
    </LinkOverlay>
    <NextImage src={src} shadow="lg" _hover={{shadow: "2xl", transform: "translateY(-10px) scale(1.05)"}} />
    <Flex
      position="absolute"
      rounded="full"
      w={32}
      h={32}
      justify="center"
      align="center"
      bg="gray.800"
      mt={-16}
      ml={-16}
      pl={2}
      top="50%"
      left="50%"
      opacity={0.9}
      border="3px solid rgba(255,255,255, .9)"
      pointerEvents="none"
    >
      <Icon color="white" size="2xl" transform="scale(200%)">
        <PlayIcon />
      </Icon>
    </Flex>
  </LinkBox>
);
